import React, { useRef } from "react";
import "@css/news/searinput.css";
import contact from "@images/contact.png";
import vs from "@images/2viewstation_logo.svg";
import analyTics from '../assets/images/analy/analy.svg';
import euci from "@images/euci.svg";
import beamer from '@images/codebeamer-black.png';
import { useState, useEffect } from "react";
import { getCIM, getVS, getTechBeamer,  getAnalyTics, getZhizong, getTechAll } from "../utils";
import { Link } from "react-router-dom";
import loading from "@images/loading.png";
import { LeftOutlined, RightOutlined } from '@ant-design/icons'


const Searchinput = () => {
  const [pageIndex, setPageIndex] = useState(1);
  const [CIM, setCIM] = useState([]);
  const [analys, setAnaly] = useState([]);
  const [VS, setVS] = useState([]);
  const [zhizong, setZhizong] = useState([]);
  const [codeBeamer, setCodeBeamer] = useState([]);
  const [allnews, setAllnews] = useState([]);
  const [load, setLoad] = useState("");
  const [current, setCurrent] = useState("");
  const [winUrlSplit, setWinUrlSplit] = useState('');
  const [showLogo, setShowLogo] = useState([
    { img: contact, check: 0, id: 0 },
    // { img: analyTics, check: 0, id: 1 },
    { img: vs, check: 0, id: 1 },
    { img: beamer, check: 0, id: 2 },
    { img: euci, check: 0, id: 3 }
  ]);
  const [hasMoreData, setHasMoreData] = useState(true); // 是否还有更多数据
  const showLogos = [
    { img: contact, check: 0, id: 0 },
    // { img: analyTics, check: 0, id: 1 },
    { img: vs, check: 0, id: 1 },
    { img: beamer, check: 0, id: 2 },
    { img: euci, check: 0, id: 3 }
  ];
  const sliderRef = useRef(null);
  const sliderContainerRef = useRef(null);


  useEffect(() => {
    const winUrl = window.location.href;
    const winUrlSplit = winUrl.split('/')[3];
    setWinUrlSplit(winUrlSplit)
  }, [window.location])


  const checkNews = () => {
    if (current === 0) {
      return CIM;
    } 
    // else if (current === 1) {
    //   return analys;
    // } 
    else if (current === 1) {
      return VS;
    } else if (current === 2) {
      return codeBeamer;
    } else if (current === 3) {
      return zhizong;
    } else if (current === "") {
      return allnews;
    }
  };

  const onClickshow = (currentItem) => {
    const { id, check } = currentItem;
    const news = showLogos;
    news.forEach((item) => {
      if (item.id === id) {
        item.check = !check;
        setShowLogo(news);
        if (item.check === false) {
          setCurrent("");
        } else if (item.check === true) {
          setCurrent(id);
        }
      }
    });
    setPageIndex(1);
  };
  const onclickMore = (i) => {
    setPageIndex(i);
  };
  // const onclickBread = (i) => {
  //   localStorage.setItem("route", "technology");

  // };
  const getList = () => {
    setLoad(false);
    let hasMore = false;
    if (current === 0) {
      getCIM(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setCIM(res.Data);
            } else {
              setCIM(() => {
                CIM.push(...res.Data);
                return [...CIM];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } 
    // else if (current === 1) {
    //   getAnalyTics(pageIndex)
    //     .then((res) => {
    //       if (!res.Message) {
    //         if (pageIndex === 1) {
    //           setAnaly(res.Data);
    //         } else {
    //           setAnaly(() => {
    //             analys.push(...res.Data);
    //             return [...analys];
    //           });
    //         }
    //         hasMore = res.Data.length > 0;
    //       }
    //     })
    //     .finally(() => {
    //       setLoad(true);
    //       setHasMoreData(hasMore);
    //     });
    // } 
    else if (current === 1) {
      getVS(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setVS(res.Data);
            } else {
              setVS(() => {
                VS.push(...res.Data);
                return [...VS];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } else if (current === 2) {
      getTechBeamer(pageIndex)
      .then((res) => {
        if (!res.Message) {
          if (pageIndex === 1) {
            setCodeBeamer(res.Data);
          } else {
            setCodeBeamer(() => {
              codeBeamer.push(...res.Data);
              return [...codeBeamer];
            });
          }
          hasMore = res.Data.length > 0;
        }
      })
      .finally(() => {
        setLoad(true);
        setHasMoreData(hasMore);
      });
    } else if (current === 3) {
      getZhizong(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setZhizong(res.Data);
            } else {
              setZhizong(() => {
                zhizong.push(...res.Data);
                return [...zhizong];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } else if (current === "") {
      getTechAll(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setAllnews(res.Data);
            } else {
              setAllnews(() => {
                allnews.push(...res.Data);
                return [...allnews];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    }
  };
  const handleScrollLeft = () => {
    sliderContainerRef.current.scrollLeft -= sliderRef.current.offsetWidth;
  };

  const handleScrollRight = () => {
    sliderContainerRef.current.scrollLeft += sliderRef.current.offsetWidth;
  };
  useEffect(() => {
    getList();
  }, [current, pageIndex, showLogo]);
  return (
    <div className="input_big flex">
      <div className="input_check flex">
        {document.body.clientWidth < 1000 && (
        <div>
          <LeftOutlined
            className="icon-left"
            onClick={handleScrollLeft}
          />
        </div>
        )}
        {/* <div className="check"></div> */}
        <div className="sear_check_center">
          <div className="slide-contain" ref={sliderContainerRef}>
            <div className="container-flex" ref={sliderRef}>
              {showLogo.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => onClickshow(item)}
                    className={item.check ? "search_background" : "search_img"}
                  >
                    <img src={item.img} alt="" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {document.body.clientWidth < 1000 && (
          <div className='long-icon right'>
            <RightOutlined
              className="icon-right"
              onClick={handleScrollRight}
            />
          </div>
        )}
      </div>
      <div className="input_four">
        <div className="input_four_text">
          {load ? (
            <>
            {checkNews().length > 0 ? (
            <div className="input_four_box">
              {checkNews().map((item, i) => {
                console.log(item);
                return (
                  <div
                    key={i}
                    className="tech_box"
                    // onClick={() => onclickBread(item.NewsTypeName)}
                  >
                    <Link to={`/detail/${item.Id}?type=${winUrlSplit}`} target="_blank" className="link-container">
                      <img src={item.FullThumbImage} alt="" />
                      <div className="tech_text">
                        <h1>{item.NewsTitle}</h1>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
            ) : (
              <p className="sear-p">暂无数据</p> // 如果没有数据，则显示“暂无数据”
            )}
            {hasMoreData && checkNews().length > 0 && (
              <button onClick={() => onclickMore(pageIndex + 1)} className="input_four_button">
                {load ? "加载更多" : "加载中..."}
              </button>
            )}
            </>
          ) : (
            <div className="sear_loading">
              <img src={loading} alt="" />
              <p>加载中...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Searchinput;
